const getValidationObserverErrors = (errorObj) => {
  return Object.keys(errorObj).reduce((result, key) => {
    if (errorObj[key].length > 0) {
      result.push({ [key]: errorObj[key][0] });
    }
    return result;
  }, []);
};

export {
  getValidationObserverErrors,
}
